import { segment } from '@actions/analytics';

class SegmentEventsUtil {
  static sendEvent = (eventData, staticData) => {
    let data = { ...staticData };
    if (eventData?.data) {
      data = {
        ...data,
        ...eventData.data
      };
    }
    if (eventData?.name) {
      segment.track(eventData.name, data);
    }
  };
}

export default SegmentEventsUtil;
